import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/react'
import { HashRouter, Switch, Route } from 'react-router-dom'

// Layout
import MainLayout from './pages/MainLayout'

// CSS
import './index.css'

// Redux
import { store, persistor } from './redux/store'
import { Provider } from 'react-redux'

// Redux Persist
import { PersistGate } from 'redux-persist/integration/react'

// Components
import Menu from './components/Menu/Menu'
import DiningOption from './components/DiningOption/DiningOption'
import PaymentPage from './components/PaymentPage/PaymentPage'

// Routes
//import AppRoute from './pages/AppRoute'
import PrivateRoute from './pages/PrivateRoute'

// Sentry
Sentry.init({
  dsn: "https://2f33d2a57af5401bb54f888e586b0129@o426805.ingest.sentry.io/5370077",
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <Switch>
        <PersistGate persistor={persistor}>
          <Route component={DiningOption} path={'/:name/'} exact />
          <PrivateRoute component={Menu} path={'/:name/menu'} layout={MainLayout} exact />
          <PrivateRoute component={PaymentPage} path={'/:name/payment'} exact />
        </PersistGate>
      </Switch>
    </HashRouter >
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();